var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"QuestionLine"},[_c('span',{staticClass:"fw-bolder"},[_vm._v(" "+_vm._s(_vm.question.label)+" ")]),_c('span',[_vm._v(" ▪ "+_vm._s(_vm.question.type.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }